import { Box, Button } from "@mui/material";
import React from "react";
import { ImgContext } from "../Context/ImageCon";

function Code(props) {
  // eslint-disable-next-line no-unused-vars
  const [img, setImg] = React.useContext(ImgContext);
  const [able, setAble] = React.useState(true);

  React.useEffect(() => {
    if (
      img !==
      "https://source.boomplaymusic.com/group10/M00/12/13/474abf0722d7419dad4d4053cb396d83_464_464.jpg"
    ) {
      setAble(false);
    }
  }, [img]);

  return (
    <div className="result">
      <Box className="QR">
        <img className="QRimg" src={img} alt="empty" />
      </Box>

      <a style={{ textDecoration: "none" }} href={img} download="QRcode.png">
        <Button variant="contained" color="primary" disabled={able}>
          Save your QR
        </Button>
      </a>
    </div>
  );
}

export default Code;
